import { segmentVersionKey } from '@/constants/modules/segment-v2/segment-adaptor';

export default [
  {
    title: 'main_menu.analytics',
    customIcon: 'AnalyticIcon',
    versionKey: segmentVersionKey,
    version: '2.0.0',
    children: [
      {
        title: 'main_menu.analytics_rfm',
        route: 'RFM',
        path: '/analytics/rfm',
      },
    ],
  },
];
